<div class="container pb-2">
  <div class="footer-container">
    <div class="links-footer">
      <button
        data-fs-element="Footer-Button-Privacy-Policy"
        matButton
        class="btn-link"
        [ngClass]="{ active: active === 'terms' }"
        (click)="openTerms()"
      >
        {{ 'HOME.FOOTER.TERMS' | translate }}
      </button>
      <button
        data-fs-element="Footer-Button-FAQ"
        matButton
        class="btn-link"
        [ngClass]="{ active: active === 'faq' }"
        (click)="openFaq()"
      >
        {{ 'HOME.FOOTER.FAQ' | translate }}
      </button>

      <a
        data-fs-element="Footer-Button-Contact"
        class="btn-link"
        href="mailto:knowledgeplatform@iadb.org"
      >
        {{ 'HOME.FOOTER.CONTACT' | translate }}
      </a>
      @if (isVisibleTour) {
        <button
          data-fs-element="Tour-Start"
          (click)="startOnboarding()"
          matButton
          class="btn-link"
          id="step-onbarding"
        >
          <mat-icon fontIcon="footprint" class="material-symbols-outlined filled icon-s"></mat-icon>
          {{ 'ONBOARDING.LABEL_FOOTER' | translate }}
        </button>
      }
      <a
        data-fs-element="Footer-Button-Support"
        class="btn-link"
        href="https://iadb.service-now.com/sp?id=sc_cat_item&table=sc_cat_item&sys_id=1aac07ba2b3e2614147cf00bb891bf00&recordUrl=com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1&sysparm_id=1aac07ba2b3e2614147cf00bb891bf00"
        target="_blank"
      >
        <mat-icon fontIcon="help" class="icon-s outline"></mat-icon>
        {{ 'HOME.FOOTER.SUPPORT' | translate }}
      </a>
    </div>
  </div>
  <div class="text-footer flex flex-justify-right mt-1">
    <p class="pl-1">{{ 'HOME.FOOTER.TEXT' | translate }}</p>
  </div>
</div>
